/**
 * Google Calendar API service functions
 */

// note, calendar api can be managed from https://console.cloud.google.com/apis/credentials

const CALENDAR_ID = 'batcitybrassband@gmail.com';
const API_KEY = 'AIzaSyBnGgDO_3AzpMODLtOs-ta0BPZkLC9I4JU';
const CALENDAR_API_URL = 'https://www.googleapis.com/calendar/v3/calendars';

/**
 * Fetches events from the Google Calendar API
 * @param {Object} options - Configuration options
 * @param {number} options.maxResults - Maximum number of events to fetch (default: 10)
 * @param {boolean} options.upcomingOnly - Whether to fetch only upcoming events (default: true)
 * @returns {Promise<Object>} - Promise that resolves to the API response
 */
export const fetchCalendarEvents = async (options = {}) => {
    const {
        maxResults = 10,
        upcomingOnly = true
    } = options;

    try {
        // Build query parameters
        const params = new URLSearchParams({
            key: API_KEY,
            maxResults: maxResults.toString(),
            singleEvents: 'true', // Expand recurring events into individual instances
            orderBy: 'startTime'
        });

        // If we want upcoming events only, set timeMin to now
        if (upcomingOnly) {
            params.append('timeMin', new Date().toISOString());
        }

        const url = `${CALENDAR_API_URL}/${encodeURIComponent(CALENDAR_ID)}/events?${params}`;
        
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        
        // Filter out private events from the initial response
        const publicEvents = (data.items || []).filter(event => event.visibility !== 'private');
        
        return {
            success: true,
            data: data,
            events: publicEvents,
            error: null
        };

    } catch (error) {
        console.error('Error fetching calendar events:', error);
        
        return {
            success: false,
            data: null,
            events: [],
            error: error.message
        };
    }
};

/**
 * Formats event data for display in the UI
 * Note: Private events are filtered out before this function is called
 * @param {Object} event - Raw calendar event object (public events only)
 * @returns {Object} - Formatted event object
 */
export const formatEventForDisplay = (event) => {
    return {
        id: event.id,
        summary: event.summary || 'Untitled Event',
        description: event.description || '',
        location: event.location || '',
        start: event.start,
        end: event.end,
        htmlLink: event.htmlLink,
        status: event.status,
        created: event.created,
        updated: event.updated
    };
};
